import NotePath from "./NotePath";
import {generateUUID} from "../../services/misc";

export type ClefType = 'treble' | 'bass';
export type HandType = 'left hand' | 'right hand';
export default class Note{
  id?: string; //uuid
  path: NotePath;
  midi: number; //e.g. 79
  tieEnd: boolean; //iirc when notes are tied together we treat them e.g. false
  offset: number; //how many seconds into the song the note resides at. Not relative to playSpeed. e.g. 0.25 or 214.5
  leftHandFinger?: number; //what finger to play the note
  duration: number; // how long the note should be played for
  durationWithTie?: number; //when 2 notes are tied together, they should be played as if they were one note with a duration equal to the duration of both notes.
  tieEndNote?: Note; //Not used, but may be useful later. if this note is the beginning of a tie, this property will be populated with the note that ends the tie. useful for scoring and changing note colors based on correctness.
  tieBeginNote?: Note; //Not used, but may be useful later.  if this note is the end of a tie, this property will be populated with the note that begins the tie. useful for scoring and changing note colors based on correctness.
  previousTieNote?: Note; //when 4 notes are tied, we want #4 to have reference to #3 so we can score it correctly.
  tabStringNumber?: number; // guitar tablature representation of the string on which the note should be played.
  tabFretNumber?: number; // guitar tablature representation of the fret number which the note resides on.
  velocity?: number; //NOTE: this doesn't come from soundslice yet, but it should, although it doesn't look like we use it.
  clef: ClefType;
  hand?: HandType;
  constructor({id = generateUUID(), path, midi, tieEnd, offset, leftHandFinger, duration, tabStringNumber, tabFretNumber, velocity, clef, hand}: Note){
    Object.assign(this, {id, path, midi, tieEnd, offset, leftHandFinger, duration, tabStringNumber, tabFretNumber, velocity, clef, hand});
  }
}
